import { Button } from "@heroui/react";
import { Icon } from "@iconify/react";

/**
 * Tells an admin their tab is running code from before the last deploy.
 *
 * Deliberately not dismissible-and-forgotten: the whole failure mode is not
 * knowing, and an admin acting on a stale screen — an order status that has
 * since changed, a form whose validation was fixed — is exactly what this is
 * here to stop. Reloading costs a second, so the bar just stays until it is.
 */
export function NewVersionBanner() {
	return (
		// sticky, not fixed: a sticky element keeps its own row, so it pushes the
		// header down instead of covering it, while staying visible on scroll.
		<div
			dir="rtl"
			className="sticky top-0 z-[9998] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-warning-500 px-3 py-1.5 text-center text-sm font-bold text-white shadow-md"
		>
			<span className="flex items-center gap-2">
				<Icon icon="lucide:refresh-cw" className="h-4 w-4 shrink-0" />
				יצאה גרסה חדשה של המערכת — המסך הזה מציג גרסה ישנה
			</span>
			<Button
				size="sm"
				className="h-7 min-w-0 bg-white px-3 font-bold text-warning-700"
				onPress={() => window.location.reload()}
			>
				רענן עכשיו
			</Button>
		</div>
	);
}
